import { jsx } from "@emotion/react/jsx-runtime";
import { useThemeProps, DevNotice } from "@wsui/base";
import PostsModuleExpandableListLayout from "./PostsModuleExpandableListLayout.mjs";
import PostsModuleListLayout from "./PostsModuleListLayout.mjs";
import PostsModuleGridLayout from "./PostsModuleGridLayout.mjs";
import PostsModuleMixedLayout from "./PostsModuleMixedLayout.mjs";
import PostsModuleInlineListLayout from "./PostsModuleInlineListLayout.mjs";
import postsModuleContext from "./postsModuleContext.mjs";
function defaultDisplayModeMapping(_ref) {
  let {
    displayMode
  } = _ref;
  switch (displayMode) {
    case "expandable-list":
      return PostsModuleExpandableListLayout;
    case "list":
      return PostsModuleListLayout;
    case "items":
    case "news":
    case "grid":
    case "index":
      return PostsModuleGridLayout;
    case "mixed":
      return PostsModuleMixedLayout;
    case "inline-list":
      return PostsModuleInlineListLayout;
  }
}
function PostsModule(props) {
  props = useThemeProps({
    props,
    name: "MunicipioPostsModule"
  });
  let {
    title,
    titleIcon,
    description,
    displayMode,
    displayModeMapping = {},
    items,
    visibleFields = ["title"],
    itemVariant,
    itemColor,
    headingPosition,
    ...restProps
  } = props;
  const ownerState = {
    title,
    titleIcon,
    description,
    displayMode,
    items,
    displayModeMapping,
    visibleFields,
    itemVariant,
    itemColor,
    headingPosition,
    ...restProps
  };
  const Component = (typeof displayModeMapping === "function" ? displayModeMapping(ownerState, defaultDisplayModeMapping) : displayModeMapping[displayMode]) || defaultDisplayModeMapping(ownerState);
  if (!Component) {
    return /* @__PURE__ */jsx(DevNotice, {
      children: `No posts module component found for displayMode=${JSON.stringify(displayMode)}`
    });
  }
  return /* @__PURE__ */jsx(postsModuleContext.Provider, {
    value: ownerState,
    children: /* @__PURE__ */jsx(Component, {
      title,
      titleIcon,
      description,
      items,
      ...restProps
    })
  });
}
export { PostsModule as default };